module.exports = __webpack_public_path__ + "img/LINE.a12c5ad3.png";